export default "__VITE_ASSET__z40Ce1K8__"